import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserRoles } from "../../../utilities/api/user/user-service";

const initialState = {
    roles: [{
        id: "",
        name: "",
        displayName: ""
    }]
}

export const GetUserRoles = createAsyncThunk("UserRole/getUserRoles", () => UserRoles())

const RolesSlice = createSlice({
    name: "UserRole",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(GetUserRoles.fulfilled, (state, action: PayloadAction<any>) => {
                state.roles = action.payload.data.roles
            })

    }
})

export default RolesSlice.reducer